import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {
    Container
} from 'reactstrap';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import withTranslation from '@intelingu/core/utils/withTranslation';
import {Link} from "react-router-dom";

export interface FooterProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class Footer extends Component<FooterProps, any> {

    render() {
        const { t } = this.props;

        return <footer>
            <Container>
                <div className={'left'}>
                    &nbsp;
                </div>
                <div className={'center'}>
                    <ul className={'nav top'}>
                        <a href={'https://home.intelingu.com/uber-uns/'} className={'nav-link'}>{ t('footerAbout') }</a>
                        <a href={'https://home.intelingu.com/impressum-2/'} className={'nav-link'}>{ t('footerContacts') }</a>
                    </ul>

                    <ul className={'nav bottom'}>
                        <a href={'https://home.intelingu.com/'} className={'nav-link'}>© Intelingu 2020</a>
                        {/*<Link to={'/subscriptions'} className={'nav-link'}>{ t('headerPricingLink') }</Link>*/}
                        <a href={'https://home.intelingu.com/datenschutz/'} className={'nav-link'}>{ t('footerTermsAndConditions') }</a>
                        <a href={'https://home.intelingu.com/impressum-2/'} className={'nav-link'}>{ t('footerPrivacy') }</a>
                    </ul>
                </div>
                <div className={'right'}>

                </div>
            </Container>
        </footer>
    }

}
